'use client';

import { useForm } from 'react-hook-form';
import { Form } from '../ui/form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { FormInput } from '../forms/form-input';
import { Button } from '../ui/button';

const formSchema = z.object({
  email: z
    .string()
    .min(1, {
      message: 'Email is required',
    })
    .email({ message: 'Please enter a valid email' }),
  firstName: z.string().min(1, { message: 'First name is required' }).max(50),
  lastName: z.string().min(1, { message: 'Last name is required' }).max(50),
});

export type NotifyInStockFormSchema = z.infer<typeof formSchema>;

export type NotifyInStockFormProps = {
  isDisabled?: boolean;
  onSubmit: (data: NotifyInStockFormSchema) => void;
};

export function NotifyInStockForm(props: NotifyInStockFormProps) {
  const form = useForm<NotifyInStockFormSchema>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
      firstName: '',
      lastName: '',
    },
    disabled: props.isDisabled,
  });

  return (
    <Form {...form}>
      <form
        className="flex flex-col gap-4"
        onSubmit={form.handleSubmit((values) => {
          props.onSubmit(values);
        })}
      >
        <FormInput
          id="email"
          type="email"
          control={form.control}
          name="email"
          label="Email"
          placeholder="E.g. jane.smith@example.com"
          className="space-y-1"
        />
        <FormInput
          id="firstName"
          type="text"
          control={form.control}
          name="firstName"
          label="First Name"
          placeholder="E.g. Jane"
          className="space-y-1"
        />
        <FormInput
          id="lastName"
          type="text"
          control={form.control}
          name="lastName"
          label="Last Name"
          placeholder="E.g. Smith"
          className="space-y-1"
        />
        <Button
          disabled={props.isDisabled}
          loader={props.isDisabled}
          className="mt-2"
        >
          Submit
        </Button>
      </form>
    </Form>
  );
}
